// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
};

export const ns = '/company';
// export const domainRaw = 'https://2853f5f58b33.ngrok-free.app';
// export const domainRaw = 'http://localhost:6500';
export const domainRaw = 'https://snatchit-api.qztbox.com';
export const domain = `${domainRaw}${ns}`;

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
